interface HTMLElementWithHandler extends HTMLElement {
  _handler?: (e: Event) => void;
}

export const VSwipeBlocker = {
  mounted(el: HTMLElementWithHandler): void {
    const handler = (e: Event) => e.preventDefault();

    el.addEventListener('touchmove', handler, { passive: false });
    el._handler = handler;
  },

  unmounted(el: HTMLElementWithHandler): void {
    if (el._handler) el.removeEventListener('touchmove', el._handler);
  },
};
